"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchRange = exports.getCalendarYearSearchRange = exports.getCalendarQuarterSearchRange = exports.getCalendarMonthSearchRange = exports.getCalendarWeekSearchRange = exports.getCalendarDaySearchRange = void 0;
const luxon_1 = require("luxon");
const error_1 = require("../../error");
const typeguards = __importStar(require("../../typeguards"));
const DayToWeekdayMap = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
};
const formatStartAndEndDates = ({ startDate, endDate, method, reportingDate, }) => {
    (0, error_1.finleyAssert)(typeguards.isFullDateStr(startDate), `${method}: unable to resolve start date for reportingDate:${reportingDate}`);
    (0, error_1.finleyAssert)(typeguards.isFullDateStr(endDate), `${method}: unable to resolve end date for reportingDate:${reportingDate}`);
    return { start: startDate, end: endDate };
};
const getCalendarDaySearchRange = ({ reportingDate, }) => ({
    start: reportingDate,
    end: reportingDate,
});
exports.getCalendarDaySearchRange = getCalendarDaySearchRange;
const getCalendarWeekSearchRange = ({ reportingDate, reportingPeriod, }) => {
    var _a;
    const weekStartDay = (_a = reportingPeriod.weekStartDay) !== null && _a !== void 0 ? _a : 'Monday';
    let startDate;
    let endDate;
    if (weekStartDay === 'Monday') {
        startDate = luxon_1.DateTime.fromISO(reportingDate).startOf('week').toISODate();
        endDate = luxon_1.DateTime.fromISO(reportingDate).endOf('week').toISODate();
    }
    else {
        // if week start set to wed = check next wed (e.g. if start of is configured to wed) & see if date falls in range, otherwise, go back to previous wednesday
        const mondayOfWeek = luxon_1.DateTime.fromISO(reportingDate).startOf('week'); // [1 = Monday, 2 = Tuesday, ..., 7 = Sunday]
        const shiftForward = mondayOfWeek.plus({
            days: DayToWeekdayMap[weekStartDay] - 1,
        });
        if (reportingDate >= shiftForward.toISODate()) {
            startDate = shiftForward.toISODate();
            endDate = shiftForward.plus({ days: 6 }).toISODate();
        }
        else {
            // we need to shift backwards
            const shiftBackwards = shiftForward.plus({ week: -1 });
            startDate = shiftBackwards.toISODate();
            endDate = shiftBackwards.plus({ days: 6 }).toISODate();
        }
    }
    return formatStartAndEndDates({
        startDate,
        endDate,
        reportingDate,
        method: 'getCalendarWeekSearchRange',
    });
};
exports.getCalendarWeekSearchRange = getCalendarWeekSearchRange;
const getCalendarMonthSearchRange = ({ reportingDate, }) => {
    const startDate = luxon_1.DateTime.fromISO(reportingDate)
        .startOf('month')
        .toISODate();
    const endDate = luxon_1.DateTime.fromISO(reportingDate).endOf('month').toISODate();
    return formatStartAndEndDates({
        startDate,
        endDate,
        reportingDate,
        method: 'getCalendarMonthSearchRange',
    });
};
exports.getCalendarMonthSearchRange = getCalendarMonthSearchRange;
const getCalendarQuarterSearchRange = ({ reportingDate, }) => {
    const startDate = luxon_1.DateTime.fromISO(reportingDate)
        .startOf('quarter')
        .toISODate();
    const endDate = luxon_1.DateTime.fromISO(reportingDate).endOf('quarter').toISODate();
    return formatStartAndEndDates({
        startDate,
        endDate,
        reportingDate,
        method: 'getCalendarQuarterSearchRange',
    });
};
exports.getCalendarQuarterSearchRange = getCalendarQuarterSearchRange;
const getCalendarYearSearchRange = ({ reportingDate, }) => {
    const startDate = luxon_1.DateTime.fromISO(reportingDate).startOf('year').toISODate();
    const endDate = luxon_1.DateTime.fromISO(reportingDate).endOf('year').toISODate();
    return formatStartAndEndDates({
        startDate,
        endDate,
        reportingDate,
        method: 'getCalendarYearSearchRange',
    });
};
exports.getCalendarYearSearchRange = getCalendarYearSearchRange;
/**
 * given a reportingDate and reportingPeriod, returns a searchRange,
 * comprised of start and end FullDateStr, inclusive
 */
const getSearchRange = ({ reportingDate, reportingPeriod, }) => {
    switch (reportingPeriod.period) {
        case 'calendarDay':
            return (0, exports.getCalendarDaySearchRange)({ reportingDate, reportingPeriod });
        case 'calendarWeek':
            return (0, exports.getCalendarWeekSearchRange)({ reportingDate, reportingPeriod });
        // TODO
        case 'calendarMonth':
            return (0, exports.getCalendarMonthSearchRange)({ reportingDate, reportingPeriod });
        case 'calendarQuarter':
            return (0, exports.getCalendarQuarterSearchRange)({ reportingDate, reportingPeriod });
        case 'calendarYear':
            return (0, exports.getCalendarYearSearchRange)({ reportingDate, reportingPeriod });
        default:
            return (0, error_1.finleyAssertUnreachable)(reportingPeriod);
    }
};
exports.getSearchRange = getSearchRange;
//# sourceMappingURL=searchRange.js.map